import { useEffect, useState } from 'react'

/**
 * The 0-based index a report citation (`[F#]`, `[S#]`) last targeted: the list it
 * names scrolls to that row and flashes it, then the index clears after `durationMs`.
 */
export function useFlashIndex(durationMs = 2200): [number | null, (index: number | null) => void] {
  const [index, setIndex] = useState<number | null>(null)
  useEffect(() => {
    if (index == null) return
    const id = setTimeout(() => setIndex(null), durationMs)
    return () => clearTimeout(id)
  }, [index, durationMs])
  return [index, setIndex]
}
